import { createBrowserRouter } from 'react-router';

import { routes } from './routes';

export const appRouter = createBrowserRouter(routes);
